import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MaintenanceComponent } from './features/ergonomics/maintenance/maintenance.component';
import { AuthGuard } from './guards/auth.guard';
import { ThemeContainerComponent } from './theme-container/theme-container.component';

const routes: Routes = [
  {
    path: 'ergo',
    component: ThemeContainerComponent,
    children: [
      {
        path: 'app',
        canActivate: [AuthGuard],
        loadChildren: () => import('./features/features.module').then((m) => m.FeaturesModule),
      },
      {
        path: 'auth',
        loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
      },
    ],
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/ergo/auth/login',
  },
  {
    path: 'maintenance',
    component: MaintenanceComponent,
  },
  {
    path: '**',
    redirectTo: '/ergo/auth/login',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
